import { render } from "./DefaultLayout.vue?vue&type=template&id=0c17871c&ts=true"
import script from "./DefaultLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefaultLayout.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/DefaultLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c17871c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c17871c', __exports__)) {
    api.reload('0c17871c', __exports__)
  }
  
  module.hot.accept("./DefaultLayout.vue?vue&type=template&id=0c17871c&ts=true", () => {
    api.rerender('0c17871c', render)
  })

}


export default __exports__